import {isNumber} from 'lodash';
import React, {FC} from 'react';
import styled from 'styled-components';

interface DropdownItemSeparatorProps {
  customMargin?: number;
}

/*
 * Style.
 */

interface StyledSeparatorDivProps {
  $customMargin?: number;
}

const StyledSeparatorDiv = styled.div<StyledSeparatorDivProps>`
  height: 1px;
  margin: ${(p) => (isNumber(p.$customMargin) ? `${p.$customMargin}px 0` : `6px 0`)};
  background-color: ${(p) => p.theme.greys.shade30};
`;

/*
 * Component.
 */

export const DropdownItemSeparator: FC<DropdownItemSeparatorProps> = (props) => (
  <StyledSeparatorDiv $customMargin={props.customMargin} />
);
